/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import NumberFormat from "react-number-format";
import Toast from "react-bootstrap/Toast";
import axios from "axios";
import "../css/contactus.css";
import FadeIn from "react-fade-in";
//  Custom CSS
const treasury = {
  width: "0px",
  opacity: 0,
  position: "absolute",
};
// End of Custom CSS

function serialize(form) {
  let inputs = form.elements;
  let testArray = {};
  for (let i = 0; i < inputs.length; i++) {
    testArray[inputs[i].id] = inputs[i].value;
  }
  return testArray;
}

function trim(theStr) {
  return theStr.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}

function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
  var retVal = "";
  var okChars = "0123456789";
  var tmpVal = trim(inVal);
  var curChar = "";
  var isDotFound = false;

  if (tmpVal !== "") {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);

      if (okChars.indexOf(curChar) !== -1) {
        if (!isDotFound && curChar === "." && isDouble) {
          isDotFound = true;
          retVal = retVal + ".";
        }

        if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }

  return retVal;
}

export default function ContactUs() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [zipcodeError, setZipCodeError] = useState("");
  const [howDidYouKnow, setHowDidYouKnow] = useState("");
  const [referrerName, setReferrerName] = useState("");
  const [selectedFile, setFileSelection] = useState(null);
  const [statesOptions, setStatesOptions] = useState("");
  const [stateList, setStateList] = useState("");
  const [honeyPot, setHoneyPot] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [thankModal, setTYModal] = useState(false);
  const [consent, setConsent] = useState(true)
  let propertyState = "";
  let zipCodeField = document.getElementById("zipCode");
  const handleTYClose = () => {
    setTYModal(false);
  };
  const [showConsentBelow, SetShowConsentBelow] = useState(false);
  const [showConsenSection, setShowConsenSection] = useState(false);
  const goBackToFirstPage = () => setShowConsenSection(false);
  const [showFail, setFailModal] = useState(false);
  const [showClickToMoreOpt, setShowClickToMoreOpt] = useState(true);
  const handleFailClose = () => setFailModal(false);
  const showPhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(false);
  };
  const hidePhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(true);
  };
  const [successToast, setSuccessToast] = useState(false);
  const [warningToast, setWarningToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  // const [url, setUrl] = useState('');
  function refreshPage() {
    window.location.reload(false);
    setTYModal(false);
  }

  const checkMimeType = (event) => {
    //getting file object
    let files = event.target.files;
    //define message container
    let err = [];
    // list allow mime type
    const types = [
      "image/png",
      "image/jpeg",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

    ];

    // loop access array
    for (var x = 0; x < files.length; x++) {
      // compare file type find doesn't matach
      if (types.every((type) => files[x].type !== type)) {
        // create error message and assign to container
        err[x] = "El formato del archivo no es compatible con la trasferencia.";
      }
    }
    for (var z = 0; z < err.length; z++) {
      // if message not same old that mean has error
      // discard selected file
      setToastMsg(err[z]);
      event.target.value = null;
      setWarningToast(true);
    }
    return true;
  };
  const maxSelectFile = (event) => {
    let files = event.target.files;
    if (files.length > 1) {
      setToastMsg("Solo se puede subir 1 archivo a la vez");
      event.target.value = null;
      setWarningToast(true);
      return false;
    }
    return true;
  };
  const checkFileSize = (event) => {
    let files = event.target.files;
    let size = 2000000;
    let err = [];
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err[x] = "El archivo es demasiado grande, seleccione un archivo más pequeño.";
      }
    }
    for (var z = 0; z < err.length; z++) {
      // if message not same old that mean has error
      // discard selected file
      setToastMsg(err[z]);
      event.target.value = null;
      setWarningToast(true);
    }
    return true;
  };

  const onChangeHandler = (event) => {
    var files = event.target.files;

    if (maxSelectFile(event) && checkMimeType(event) && checkFileSize(event)) {
      setFileSelection(files);
    }
    if (files.length > 0) {
      setWarningToast(false);
    }
  };
  //Below is the function to remove non-printable ASCII chars
  //and special chars from the pass string
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === "") {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }
  //first name validation
  const handleFirstName = (evt) => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    if (tempFirstName) {
      if (tempFirstName.includes(" ") && lastName === "") {
        const name = tempFirstName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setFirstName(tempFirstName.trim());
      }
    } else {
      setFirstName("");
    }
  };

  //last name validation
  const handleLastName = (evt) => {
    let tempLastName = evt.currentTarget.value;
    tempLastName = removeNonAsciiSpecialCharacters(tempLastName);
    if (tempLastName) {
      if (tempLastName.includes(" ") && firstName === "") {
        const name = tempLastName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setLastName(tempLastName.trim());
      }
    } else {
      setLastName("");
    }
  };
  const handleEmailAddress = (evt) => {
    let tempEmailAddress = evt.currentTarget.value;
    if (tempEmailAddress) {
      setEmail(tempEmailAddress.trim());
    } else {
      setEmail("");
    }
  };

  const handleTelephoneNumber = (evt) => {
    //Save Phone number in local storage for Apply

    var tmpVal = trim(getNumbers(evt.currentTarget.value, false, "01"));
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = "";
      return;
    }

    var curChar = "";

    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = "";

    /* 6/13/2020 - Dennis
      Do not put the parentesis if we only have the first three digits of the phone number.
      Once we are past that then start formatting the phone number. This was the main issue
      why the phone number couldn't be blanked out in it's entirety.
    */
    if (areaCode !== "" && firstThree === "") retVal += areaCode;
    else if (areaCode !== "" && firstThree !== "")
      retVal += "(" + areaCode + ")";

    if (firstThree !== "") retVal += " " + firstThree;

    if (lastFour !== "") retVal += "-" + lastFour;

    if (extension !== "") retVal += " x" + extension;
    else
      setPhoneNumber(retVal);
  };

  function changeClass(ename) {
    ename.target.className = "form-control";
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  // function gtag_report_conversion(url) {
  //   var callback = function () {
  //     if (typeof url != "undefined") {
  //       window.location = url;
  //     }
  //   };
  //   window.gtag("event", "conversion", {
  //     send_to: "AW-10797929395/q0b4CNbl8q0DELOn7Zwo",
  //     event_callback: callback,
  //   });
  //   return false;
  // }

  useEffect(() => {
    // window.gtag("config", "AW-10797929395");

    axios
      .post(
        "https://vo4bm2sbhi.execute-api.us-east-1.amazonaws.com/prod/public/state/list",
        { companyCode: "SUNWST000", domain: "ny.swmc.com" },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((response) => {
        setStateList(response.data);
        setStatesOptions(
          response.data.map((item, index) => (
            <option key={index} value={item.code}>
              {item.name}
            </option>
          ))
        );
      });
  }, []);

  function updateZipCode(propZipCode) {
    setZipcode(propZipCode);

    if (propZipCode.length === 5) {
      axios
        .get(
          process.env.REACT_APP_ZIPCODE
          +
          propZipCode,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          propertyState = stateList.filter(
            (state) => state.code == response.data.state
          );
          setState(response.data.state);
        })
        .catch((e) => {
          setZipCodeError(e.response.data.error);
          setZipcode("");
        });
    }

    if (propZipCode.length < 5) {
      setZipCodeError("");
      zipCodeField.style.borderColor = "#ced4da";
      zipCodeField.classList.remove("is-invalid");
      zipCodeField.removeAttribute("required");
    }
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    document.getElementById("scroll").scrollIntoView({ behavior: 'instant' });

    if (form.checkValidity() === false) {
      if (zipcodeError) {
        zipCodeField.setAttribute("required", "");
        zipCodeField.classList.add("is-invalid");
        zipCodeField.style.borderColor = "#dc3545";
      }
      event.stopPropagation();
    } else {
      if (!honeyPot && !zipcodeError) {
        if (!showConsenSection) {
          setFormLoading(true);

          const data = document.querySelector("#contactForm");
          let contactForm = document.getElementById("contactForm");
          const getData = serialize(data);
          getData.howDidYouKnow = howDidYouKnow;

          //upload file to aws
          if (selectedFile && selectedFile.length > 0) {
            var fileParts = selectedFile[0].name.split(".");
            var file = fileParts[0].replace(/\s/g, "") + Date.now();
            var fileName = file + "." + fileParts[1];
            const baseFile = await toBase64(selectedFile[0]);
            const body = {
              file: baseFile,
              name: fileName,
            };
            setFormLoading(false);
            setTYModal(false);
            setShowConsenSection(true);
            setFailModal(false);
          } else {

            // gtag_report_conversion();
            setFormLoading(false);
            setTYModal(false);
            setShowConsenSection(true);
            setFailModal(false);
            contactForm.classList.remove("was-validated");
          }

        }
        else {
          setFormLoading(true);

          const data = document.querySelector("#contactForm");
          let contactForm = document.getElementById("contactForm");
          const getData = serialize(data);
          getData.howDidYouKnow = howDidYouKnow;
          //upload file to aws
          if (selectedFile && selectedFile.length > 0) {
            var fileParts = selectedFile[0].name.split(".");
            var file = fileParts[0].replace(/\s/g, "") + Date.now();
            var fileName = file + "." + fileParts[1];
            const baseFile = await toBase64(selectedFile[0]);
            const body = {
              file: baseFile,
              name: fileName,
            };

            axios
              .post(
                "https://q8z4cha35j.execute-api.us-east-1.amazonaws.com/default/python-s3-upload-sunwestconnect",
                body
              )
              .then((response) => {
                getData.jobFile = response.data.URL;

                axios
                  .post(
                    "https://mgas7gtu47.execute-api.us-east-1.amazonaws.com/default/SunWestConnect",
                    getData
                  )
                  .then((res) => {
                    setFormLoading(false);
                    setTYModal(true);
                    setShowConsenSection(false);
                    setFailModal(false);
                    contactForm.classList.remove("was-validated");
                    contactForm.reset();
                    setFirstName("");
                    setLastName("");
                    setPhoneNumber("");
                    setEmail("");
                    setAddress("");
                    setCity("");
                    setState("");
                    setZipcode("");
                    setHowDidYouKnow("");
                    setReferrerName("");
                    setValidated(false);
                  })
                  .catch(function (error) {
                    setFailModal(true);
                    contactForm.classList.remove("was-validated");
                    setValidated(false);
                    contactForm.reset();
                    console.log(
                      "development error status " + JSON.stringify(error)
                    );
                  });
              })
              .catch((error) => {
                setFailModal(true);
                // alert(JSON.stringify(error));
              });
          } else {
            axios
              .post(
                "https://mgas7gtu47.execute-api.us-east-1.amazonaws.com/default/SunWestConnect",
                getData
              )
              .then((res) => {
                // gtag_report_conversion();
                setFormLoading(false);
                setTYModal(true);
                setShowConsenSection(false);
                setFailModal(false);
                contactForm.classList.remove("was-validated");
                contactForm.reset();
                setFirstName("");
                setLastName("");
                setPhoneNumber("");
                setEmail("");
                setAddress("");
                setCity("");
                setState("");
                setZipcode("");
                setHowDidYouKnow("");
                setReferrerName("");
              })
              .catch(function (error) {
                setFailModal(true);
                contactForm.classList.remove("was-validated");
                contactForm.reset();
                console.log("development error status " + JSON.stringify(error));
              });
          }
        }
      }
    }
    setValidated(true);
  };

  return (
    <>
      <Container fluid className="contact-section">
        <Row className="form-wrapper justify-content-center">
          <Col md={12} lg={10} xl={8}>
            <Form
              className="contact-form"
              id="contactForm"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <Row>
                <Col className="text-center mb-3">
                  <h5 className="mb-1">
                    SI ESTAS BUSCANDO HACER LA DIFERENCIA, ESTE ES EL LUGAR PARA ESTAR.
                  </h5>
                  <h6>Si solo estás buscando trabajo, no solicites aquí.</h6>
                </Col>
              </Row>
              <div className={showConsenSection ? "d-none" : "d-block"}>
                <Form.Row style={treasury}>
                  <Form.Group as={Col} sm={5} controlId="sunwest_name">
                    <strong>
                      <Form.Label>* Sun West Name: </Form.Label>
                    </strong>
                    <Form.Control
                      type="text"
                      minLength="2"
                      maxLength="12"
                      data-error="Please fill out this field correctly."
                      onChange={(e) => setHoneyPot(true)}
                    />
                    <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} sm={5} controlId="sunwest_code">
                    <strong>
                      <Form.Label>* Sun West Code: </Form.Label>
                    </strong>
                    <Form.Control
                      type="text"
                      pattern="^[0-9a-zA-Z]{4}$"
                      maxLength="4"
                      data-error="Please fill out this field correctly."
                      onChange={(e) => setHoneyPot(true)}
                    />
                    <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row className="justify-content-around">
                  <Form.Group as={Col} md="5" controlId="firstName">
                    <Form.Label>Nombre*</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder="Ingrese el Nombre"
                      value={firstName}
                      required
                      onBlur={handleFirstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);

                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Se requiere Primer Nombre
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="5" controlId="lastName">
                    <Form.Label>Apellido*</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      placeholder="Ingrese el Nombre"
                      value={lastName}
                      required
                      onBlur={handleLastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      Se Requiere Apellido
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row className="justify-content-around">
                  <Form.Group as={Col} md="5" controlId="userEmail">
                    <Form.Label>Dirección del Email*</Form.Label>
                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Ingrese Dirección del Email"
                      value={email}
                      required
                      pattern="^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,64})$"
                      onChange={handleEmailAddress}
                    />
                    <Form.Control.Feedback className='validemail' type="invalid">Su Email es requerido</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} md="5" controlId="userPhone">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingrese el Número de Teléfono"
                      minLength={14}
                      maxLength={21}
                      pattern="^\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})[ ]*(( |x){1}[ ]?([0-9]){1,7}){0,1}$"
                      onChange={handleTelephoneNumber}
                      autoComplete="off"
                      value={PhoneNumber}
                      onFocus={changeClass.bind(this)}

                    />
                    <Form.Control.Feedback type="invalid">Número de teléfono es requerido</Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row className="justify-content-around">
                  <Form.Group as={Col} md="5" controlId="streetAddress">
                    <Form.Label>Dirección</Form.Label>
                    <Form.Control
                      type="text"
                      name="streetAddress"
                      placeholder="Ingrese Dirección de la Calle"
                      value={address}
                      onChange={(e) => {
                        setAddress(e.target.value);
                      }}
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="5" controlId="zipCode">
                    <Form.Label>Zip Code</Form.Label>
                    <NumberFormat
                      className="form-control"
                      id="zipCode"
                      placeholder="Ingrese Zip Code"
                      format="#####"
                      value={zipcode}
                      displayType={"input"}
                      thousandSeparator={false}
                      fixedDecimalScale={true}
                      onValueChange={(values) => {
                        updateZipCode(values.value);
                      }}
                    />
                    {zipcodeError ? (
                      <p className="text-danger mb-0">{zipcodeError}</p>
                    ) : null}
                    <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
                <Form.Row className="justify-content-around">
                  <Form.Group as={Col} md="5" controlId="city">
                    <Form.Label>Ciudad</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      placeholder="Ingresar Código Postal"
                      value={city}
                      onChange={(e) => {
                        setCity(e.target.value);
                      }}
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="5" controlId="state">
                    <Form.Label>Estado</Form.Label>
                    <Form.Control
                      value={state}
                      name="state"
                      placeholder="Estado"
                      onChange={(e) => setState(e.target.value)}
                      as="select"
                      custom
                      disabled
                    >
                      <option value="">Estado</option>
                      {statesOptions}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>

                <Form.Row className={"justify-content-around"}>
                  <Form.Group as={Col} md="5">
                    <Form.Label>¿Cómo se enteró de nosotros?</Form.Label>
                    <Form.Control
                      as="select"
                      name="howDidYouKnow"
                      value={howDidYouKnow}
                      onChange={(e) => {
                        setHowDidYouKnow(e.target.value);
                      }}
                    >
                      <option value="">Seleccione una opción</option>
                      <option value="Referral">Referido</option>
                      <option value="Social media">Medios de Redes Social</option>
                      <option value="Job portals">Portales de Empleo</option>
                      <option value="Google">Google</option>
                      <option value="Other">Otro</option>
                    </Form.Control>
                  </Form.Group>

                  <Form.Group as={Col} md="5" controlId="Referrer">
                    {howDidYouKnow === "Referral" ? (
                      <FadeIn>
                        <Form.Label>Nombre de Referencia</Form.Label>
                        <Form.Control
                          type="text"
                          name="referrer"
                          placeholder="Ingrese el Nombre de Referencia"
                          value={referrerName}
                          onChange={(e) => {
                            setReferrerName(e.target.value);
                          }}
                        />
                      </FadeIn>
                    ) : null}
                  </Form.Group>
                </Form.Row>
                <Form.Row className="justify-content-around">
                  <Form.Group as={Col} md={8} lg={5} className="minscreen minimum-screen">
                    <strong>
                      <Form.Label>Subir Resume</Form.Label>
                    </strong>
                    <div className="custom-file">
                      <Form.Control
                        type="file"
                        className="custom-file-input"
                        onChange={onChangeHandler}
                        id="validatedCustomFile"
                        accept=".doc, .docx,.pdf"
                      />

                      <Form.Label
                        className="custom-file-label"
                        value="selected"
                        htmlFor="validatedCustomFile"
                      >
                        {selectedFile &&
                          selectedFile.length > 0 &&
                          selectedFile[0].name ? (
                          <span className="filename-trim">
                            {selectedFile[0].name}{" "}
                          </span>
                        ) : (
                          "Seleccione su Resume..."
                        )}
                      </Form.Label>
                      <Form.Control.Feedback type="invalid">
                        Seleccione un archivo.
                      </Form.Control.Feedback>
                      <Toast
                        show={warningToast}
                        delay={5000}
                        className="error-msg-block"
                        autohide
                      >
                        <Toast.Header closeButton={false}>
                          <strong className="mr-auto error-msg">
                            {toastMsg}
                          </strong>
                        </Toast.Header>
                      </Toast>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col} md={{ span: 2, offset: 3 }}>
                    <Toast
                      onClose={() => setSuccessToast(false)}
                      show={successToast}
                      delay={5000}
                      className="border-success"
                      autohide
                    >
                      <Toast.Header>
                        <strong className="mr-auto">{toastMsg}</strong>
                      </Toast.Header>
                    </Toast>
                  </Form.Group>
                </Form.Row>
                <Row className="justify-content-around">
                  <Col md={11}>
                    <p className="tcpa">

                      <br />
                      Al hacer clic en Aplicar Ahora, usted acepta los{" "}
                      <a
                        href="https://www.swmc.com/terms-and-conditions.php"
                        target="_blank"
                      >
                        Términos y Condiciones
                      </a>{" "}
                      y la{" "}
                      <a
                        href="https://www.swmc.com/privacy-policy.php"
                        target="_blank"
                      >
                        Política de Seguridad y Privacidad
                      </a>{" "}
                      de NMLS 3277 ("Sun West") de Sun West Mortgage Company, Inc. y usted acepta los
                      {" "}<a
                        href="https://www.celligence.com/terms"
                        target="_blank"
                      >
                        Términos y Condiciones
                      </a>{" "} y la {" "}
                      <a
                        href="https://www.celligence.com/privacy"
                        target="_blank"
                      >
                        Política de Seguridad y Privacidad
                      </a>{" "}
                      de Celligence International, LLC. ("Celligence"), a los cuales puede acceder haciendo clic en los enlaces web "Términos y Condiciones" o "Política de Seguridad" que se encuentran en este documento.
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col className="text-center mb-3">
                    <button
                      className="d-grid clrd-btn apply-text text-white text-center"
                      type="submit"
                      id="btnApply"
                    >
                      {formLoading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="md"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Solicitar Ahora"
                      )}
                      {formLoading ? " Enviando..." : ""}
                    </button>
                  </Col>
                </Row>
              </div>
              <div className={showConsenSection ? "d-block" : "d-none"}>
                <Form.Row className=" ">
                  <div className="d-flex">
                    {showClickToMoreOpt ? (
                      <h6
                        className="consentSmall"
                        onClick={showPhoneSoliticationConsent}
                      >
                        {"¿Acepta la solicitud telefónica automatizada?"}{" "}
                        <span
                          id="showConsentText"
                          className="consentLink showConsentText"
                          title="Show Phone Solicitation Consent"
                        >
                          (Haga clic para mostrar más)
                        </span>
                      </h6>
                    ) : (
                      <h6
                        className="consentSmall"
                        onClick={hidePhoneSoliticationConsent}
                      >
                        {"¿Acepta la solicitud telefónica automatizada?"}{" "}
                        <span
                          id="hideConsentText"
                          className="consentLink hideConsentText"
                          title="Hide Phone Solicitation Consent"
                        >
                          (Haga clic para mostrar menos)
                        </span>
                      </h6>
                    )}
                  </div>
                  <Container>
                    {!showClickToMoreOpt ? (
                      <p className="content1">Al hacer clic en Acepto a continuación, usted da su consentimiento expreso para que Sun West Mortgage Company, Inc. haga (o permita que se realice en su nombre) llamada telefónica,  mensaje de texto o transmisión de correo de voz al número de teléfono que ingresó anteriormente con el propósito de solicitar su compra de bienes de consumo o servicios (incluyendo el uso de sistema automatizado para la selección o marcación de números de teléfono, la reproducción de mensaje grabado cuando se realiza una conexión o la transmisión de un correo de voz pregrabado), incluso si ese número de teléfono está en un Registro nacional, estatal o interno de No Llamar. No está obligado a hacer clic en Yo Consiento (directa o indirectamente) ni aceptar recibir dichas llamadas telefónicas, mensajes de texto o transmisiones de correo de voz como condición para obtener cualquier bien o servicio de Sun West Mortgage Company, Inc. o sus afiliados.
                      </p>
                    ) : (
                      ""
                    )}
                  </Container>

                </Form.Row>
                <Form.Row className="justify-content-start mt-3">
                  <Form.Group controlId="TCPA_Consent_Given" >
                    <Container className="temp3">
                      <Row className="justify-content-start align-items-center checkers">
                        <div onClick={() => setConsent(true)}>
                          <Form.Control
                            onChange={() => setConsent(true)}
                            type="checkbox"
                            name="TCPA_Consent_Given"
                            value={consent}
                            checked={consent}
                          />
                          <p>Yo Acepto</p>
                        </div>
                        <div onClick={() => setConsent(false)}>
                          <Form.Control
                            onChange={() => setConsent(false)}
                            type="checkbox"
                            name="TCPA_Consent_Given"
                            value={consent}
                            checked={!consent}
                          />
                          <p>Yo No Acepto</p>
                        </div>
                      </Row>
                    </Container>
                  </Form.Group>
                </Form.Row>

                <Form.Row className="justify-content-start pt-3">
                  <Row className="align-items-center">
                    <div >
                      <div className={showConsenSection ? "d-block" : "d-none"} >
                        <Col>
                          <div >
                            <Button
                              className=" clrd-btn btn-submit"
                              type="button"
                              onClick={goBackToFirstPage}
                            >
                              Atrás
                            </Button>
                          </div>
                        </Col>
                      </div>
                    </div>
                    <Col ></Col>
                    <Col>
                      <button
                        className="clrd-btn apply-text text-white text-center"
                        type="submit"
                        id="btnApply"
                      >
                        {formLoading ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="md"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Continuar"
                        )}
                        {formLoading ? " Enviando..." : ""}
                      </button>
                    </Col>
                  </Row>
                </Form.Row>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      <Modal
        size="lg"
        centered
        show={thankModal}
        onHide={handleTYClose}
        backdrop="static"
      >
        <Modal.Body>
          <h4 className="main-blue text-center">
            Gracias por comunicarse con Sun West Mortgage Company, Inc. Responderemos su mensaje lo antes posible.
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleTYClose}>Cerca</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
